import axios from '../../axios';

export type ServiceResponse = {
  id: string;
  clientCode: string;
  clientName: string;
  taxId: string;
  balance: string;
  reconciliationStatus: string;
  documentCount: string;
  type: string;
  status: statusEnum;
};

type statusEnum = 'AGREED' | 'NOT_AGREED' | 'OTHER';

export type ServiceRequest = {
  month: string;
  year: string;
  type: string;
};

export default async function getProcessualDemands(): Promise<ServiceResponse[]> {
  const res = await axios.get(`${process.env.REACT_APP_BASE_URL}/case?isTask=true`);
  return res.data;
}
